import { StateCreator } from 'zustand';
import { WorkspaceStore } from './types';

export const createWorkspaceSlice: StateCreator<WorkspaceStore> = (set, get) => ({
  // Initial state
  currentWorkspace: null,
  workspaces: [],
  selectedWorkspaceId: null,

  // Actions
  setCurrentWorkspace: (workspace) => set({ currentWorkspace: workspace }),
  setWorkspaces: (workspaces) => set({ workspaces }),
  selectWorkspace: (workspaceId) => set({ selectedWorkspaceId: workspaceId }),

  // Selectors
  getCurrentWorkspace: () => get().currentWorkspace,
  getSelectedWorkspaceId: () => get().selectedWorkspaceId,
  getAllWorkspaces: () => get().workspaces,
});
